import { render, staticRenderFns } from "./widget-pagination.vue?vue&type=template&id=1cea0a50&scoped=true"
import script from "./widget-pagination.vue?vue&type=script&lang=js"
export * from "./widget-pagination.vue?vue&type=script&lang=js"
import style0 from "./widget-pagination.vue?vue&type=style&index=0&id=1cea0a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cea0a50",
  null
  
)

export default component.exports